<template>
  <span class="app-wordmark" :style="wordmarkStyle">Sinutech Pagos</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

// Kept the same prop shape as the logo this replaces (VuesticLogo.vue) so every call site
// — AuthLayout, AppNavbar, 404 — needed only an import/tag rename, no prop rewrites.
// `end` no longer has any effect (a text wordmark has no gradient) but stays in the type so
// passing it is harmless rather than a type error.
const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 18,
    start: 'primary',
    end: undefined,
  },
)

const wordmarkStyle = computed(() => ({
  color: getColor(props.start),
  fontSize: `${Math.round(props.height * 0.85)}px`,
}))
</script>

<style scoped>
.app-wordmark {
  display: inline-block;
  font-family: var(--va-font-family-heading);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1;
  white-space: nowrap;
}
</style>
